import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { Palette } from "../AppConfig";
import { Tooltip } from "@mui/material";

const StyledButton = withStyles((theme) => ({
    root: {
        font: theme.brand?.FIELDERS
            ? "200 11pt " + Palette.Fielders.FontFamilySecondary
            : "400 14px " + Palette.Lysaght.FontFamily,
        lineHeight: "1.75",
        padding: "6px 20px",
        minWidth: "35px",
        background: theme.brand?.FIELDERS ? Palette.FieldersBlue : Palette.Lysaght.DarkBlue,
        color: "white",
        boxShadow: "none",
        width: "fit-content",
        maxwidth: "200px",
        selected: {
            background: theme.brand?.FIELDERS ? Palette.FieldersBlue : Palette.Lysaght.DarkBlue,
            color: "white !important",
        },
        "&:hover": {
            color: "white !important",
            background: theme.brand?.FIELDERS
                ? Palette.Fielders.HoverButtonBlue + " !important"
                : Palette.Lysaght.LightBlue + " !important",
        },
        "&:hover label": {
            color: "white",
        },
    },
    disabled: {
        background: "#FFFFFF00 !important",
        color: Palette.Control.Grey + " !important",
    },
}))(Button);

const StyledButtonSecondary = withStyles((theme) => ({
    root: {
        font: theme.brand?.FIELDERS
            ? "200 11pt " + Palette.Fielders.FontFamilySecondary
            : "400 14px " + Palette.Lysaght.FontFamily,
        lineHeight: "1.75",
        padding: "6px 20px",
        minWidth: "35px",
        background: "#FFFFFF00",
        color: theme.brand?.FIELDERS ? Palette.FieldersBlue : Palette.Lysaght.DarkBlue,
        boxShadow: "none",
        width: "fit-content",
        maxwidth: "200px",
        "&:hover": {
            color: theme.brand?.FIELDERS ? Palette.FieldersBlue : Palette.Lysaght.LightBlue,
            background: "#FFFFFF00",
        },
        "&:hover label": {
            color: theme.brand?.FIELDERS ? Palette.FieldersBlue : Palette.Lysaght.LightBlue,
        },
        border: "1px solid #192E61",
        padding: "6px",
    },
    disabled: {
        background: "white !important",
        color: Palette.Control.Grey + " !important",
    },
}))(Button);

const useStyles = makeStyles({
    tight: {
        fontSize: "10pt",
        padding: "2px 10px",
    },
});

export default function BSL_Button(props) {
    const classes = useStyles();

    if (props.secondary)
        return (
            <Tooltip title={props.disabled && props.disabledTooltip ? props.disabledTooltip : ""}>
                <StyledButtonSecondary
                    {...props}
                    secondary=""
                    tight=""
                    className={props.className + " " + (props.tight ? classes.tight : "")}
                    onClick={(e) => (props.onClick ? props.onClick(e) : "")}
                    variant="contained"
                    style={props.style ? props.style : {}}
                    selected
                >
                    {props.children ? props.children : props.label}
                </StyledButtonSecondary>
            </Tooltip>
        );

    return (
        <Tooltip title={props.disabled && props.disabledTooltip ? props.disabledTooltip : ""}>
            <StyledButton
                {...props}
                tight=""
                className={props.className + " " + (props.tight ? classes.tight : "")}
                onClick={(e) => (props.onClick ? props.onClick(e) : "")}
                variant="contained"
                style={props.style ? props.style : {}}
            >
                {props.children ? props.children : props.label}
            </StyledButton>
        </Tooltip>
    );
}
